import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SpinnerServiceModel } from "../models/spinner-service.model";

@Injectable({
    providedIn: 'root'
  })
  export class SpinnerModalService extends SpinnerServiceModel{
    spinner$: Observable<boolean> = new Observable();
    constructor(){
        super(new BehaviorSubject<boolean>(false));
        this.spinner$ = this.spinnerSubject.asObservable();
    }
}